import { render } from "./CardObjectSelection.vue?vue&type=template&id=0053042a&scoped=true"
import script from "./CardObjectSelection.vue?vue&type=script&lang=js"
export * from "./CardObjectSelection.vue?vue&type=script&lang=js"

import "./CardObjectSelection.vue?vue&type=style&index=0&id=0053042a&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0053042a"]])

export default __exports__